export enum ScreensLocationScreenByTitle {
  ListingLocation = 'Listing Location',
  CompanyHQ = 'Company HQ',
}
